<template>
  <div>
    <!-- 评估安排通知 -->
    <div
      class="gwnl-eval-publish-msg__title standard-size-16 color-gray-10 font-weight-500"
    >
      {{ $t('pc_gwnl_eval_notifiAssessArrange') }}
    </div>

    <div class="mt16 ml15">
      <yxt-checkbox
        v-model="enabledNotify"
        :true-label="1"
        :false-label="0"
        @change="changeNotify"
      >
        {{ $t('pc_gwnl_eval_sendNotifiArrange') }}
      </yxt-checkbox>
    </div>

    <div v-if="enabledNotify === 1" class="ml40">
      <yxt-radio v-model="customization" :label="0" class="mt24 mb24">
        {{ $t('pc_gwnl_eval_useDefaultTemplate') }}
      </yxt-radio>
      <br />
      <yxt-radio v-model="customization" :label="1">
        {{ $t('pc_gwnl_eval_usePersonalizedTemplates') }}
      </yxt-radio>
      <span v-if="customization === 1" class="yxt-radio__input">
        <span
          class="color-primary-6 mr16 hand"
          @click="showTemplate(tCode)"
        >
          {{ $t('pc_gwnl_eval_eval_notify') }}
        </span>
      </span>
    </div>
    <!-- 定时消息设置 -->
    <div v-if="enabledNotify === 1 && !noTiming" class="gwnl-eval-publish-timing mt32 pb24">
      <div
        class="gwnl-eval-publish-msg__title standard-size-16 color-gray-10 font-weight-500"
      >
        <div class="align-items-center">
          <span>{{ $t('pc_gwnl_eval_timedMsgSettings') }}</span>
          <yxt-tooltip
            effect="dark"
            placement="top"
            :content="$t('pc_talent_tips_eval_send_notice').d('定时发送评估安排通知')"
          >
            <yxt-svg
              class="ml4 color-gray-6 v-mid"
              width="16px"
              height="16px"
              icon-class="question-cirlce-o"
            />
          </yxt-tooltip>
        </div>
      </div>

      <div class="mt16 ml15">
        <yxt-checkbox
          v-model="scheduled"
          :true-label="1"
          :false-label="0"
          @change="changeScheduled"
        >
          <span class="color-gray-9">
            {{ $t('pc_gwnl_eval_timedMsgSettings') }}</span
          >
        </yxt-checkbox>
      </div>

      <yxt-form
        v-if="scheduled === 1"
        ref="dynamicValidateForm"
        :model="dynamicValidateForm"
        label-width="0px"
        class="ml40 mt24"
      >
        <yxt-form-item
          v-for="(item, index) in scheduleList"
          :key="index"
          class="gwnl-eval-publish__schedule"
          :prop="'scheduleList.' + index + '.notifyTime'"
          :rules="timeRules"
        >
          <span ref="pbText" class="mr12 d-in-block">{{ $t('pc_gwnl_eval_willBe') }}</span>
          <yxt-date-picker
            v-model="item.notifyTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('pc_gwnl_eval_selectDateAndTime')"
            :picker-options="pickerOptions"
          />
          <span class="ml12">{{ $t('pc_talent_msg_eval_send_notify').d('发送评估安排通知') }}</span>
        </yxt-form-item>
      </yxt-form>

      <div v-if="scheduled === 1" class="mt24 ml40 yxtbiz-flex-center">
        <span class="vertical-align--middle">{{
          $t('pc_gwnl_eval_messageSendingChannel')
        }}</span>
        <yxt-svg
          v-for="icon in msgList"
          :key="icon"
          :remote-url="`${$staticBaseUrl}ufd/b0174a/evaluation/pc/svg/eval`"
          class="ml12 vertical-align--middle"
          width="24px"
          height="24px"
          :icon-class="icon"
        />
      </div>
    </div>

    <yxtbiz-i18n-custom-template
      :code="tCode"
      :target-id="id"
      :visible.sync="visible[tCode]"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getPublishEval } from '../service.js';
import handleError from '../handleError';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    noTiming: {
      type: Boolean,
      default: false
    },
    // 是否是user-management组件
    isUser: {
      type: Boolean,
      default: false
    }
  },
  mixins: [handleError],
  data() {
    const validateTime = (rule, value, callback) => {
      if (!value) {
        this.setTextWidth();
        callback(new Error(this.$t('pc_gwnl_eval_pleaseSelectDateAndTime')));
      }

      callback();
    };
    return {
      loading: false,
      tCode: 'talent_eval_notify',
      enabledNotify: 1, // 是否发送评估安排变更通知
      scheduled: 0, // 是否开启定时消息设置
      customization: 0, // 是否使用个性通知模板
      scheduleList: [{ notifyTime: '' }],
      msgList: ['mail', 'app', 'dd', 'wx', 'msg'],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < dayjs().startOf('day');
        }
      },
      visible: {
        talent_eval_notify: false,
        selfVisible: false,
        leaderVisible: false,
        equalVisible: false,
        subordinateVisible: false
      }, // 个性模板配置弹框显示
      timeRules: {
        required: true,
        validator: validateTime,
        trigger: 'blur'
      }
    };
  },

  computed: {
    dynamicValidateForm() {
      return {
        scheduleList: this.scheduleList
      };
    }
  },

  created() {
    // 如果是人员管理组件，则直接使用默认值，不需要调用接口
    if (this.isUser || !this.id) return;
    this.getPublishEval();
  },

  methods: {
    getPublishEval() {
      if (!this.id) return;
      this.loading = true;
      getPublishEval(this.id)
        .then(res => {
          this.loading = false;
          this.enabledNotify = res.enabledNotify;
          this.scheduled = res.scheduled;
          this.customization = res.customization;
          this.scheduleList = res.scheduleList;
          this.$emit('get-info', res);
        })
        .catch(err => {
          this.loading = false;
          this.handleError(err);
        });
    },
    changeNotify(value) {
      if (value === 0) {
        this.customization = 0;
        this.scheduled = 0;
      }
    },
    changeScheduled(value) {
      if (value === 1) {
        this.scheduleList = [{ notifyTime: '' }];
      } else {
        this.scheduleList = [];
      }
    },
    showTemplate(name) {
      console.log('eval', name);
      this.visible[`${name}`] = true;
    },
    setTextWidth() {
      this.$nextTick(() => {
        const textWidth = this.$refs.pbText[0].clientWidth + 12;
        const itemError = document.querySelector('.yxt-form-item__error');
        itemError.style.left = textWidth + 'px';
      });
    },

    validateForm(callback) {
      if (this.scheduled === 1) {
        this.$refs.dynamicValidateForm.validate(valid => {
          if (valid) {
            callback && callback();
          } else {
            return false;
          }
        });
      } else {
        callback && callback();
      }
    },

    // 获取发布的参数
    getPublishParams() {
      return {
        customization: this.customization,
        enabledNotify: this.enabledNotify,
        scheduleList: this.isUser ? [] : this.dynamicValidateForm.scheduleList.map(
          (item, index) => {
            return {
              notifyTime: item.notifyTime,
              orderIndex: index
            };
          }
        ),
        scheduled: this.isUser ? 0 : this.scheduled
      };
    }
  }
};
</script>

<style lang="scss">
.gwnl-eval-publish-msg__title {
  position: relative;
  padding-left: 15px;

  &::before {
    position: absolute;
    top: 6px;
    left: 0;
    width: 3px;
    height: 12px;
    background: #436bff;
    content: '';
  }
}
</style>